import { FC } from 'react';

import Button from 'components/_core/Button';

import { useFormContext } from '../../../../form';
import locales from '../../locales';

const AddVatFormActions: FC<{
  isEditing: boolean;
  isLoading: boolean;
  onSave: () => void;
  onCancel: () => void;
}> = ({ isEditing, isLoading, onCancel, onSave }) => {
  const { formState } = useFormContext();
  if (!isEditing) {
    return null;
  }

  return (
    <Button
      isDisabled={!formState.isValid}
      isLoading={isLoading}
      onClick={formState.isDirty ? onSave : onCancel}
      variant="inline-primary"
    >
      {formState.isDirty ? locales.validate : locales.cancel}
    </Button>
  );
};

export default AddVatFormActions;
